export const label = 'font-medium block text-base font-body text-textDark';
